<template>
  <div class="banner-wrapper">
    <div class="banner-image">
      <img :src="bannerImg" alt="banner" />
    </div>
    
    <div class="banner-overlay">
      <div class="container-fixed search-container">
        <div class="search-box">
          <input 
            type="text" 
            placeholder="搜索您感兴趣的内容..." 
            v-model="keyworder" 
            @keyup.enter="getSeach"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="getSeach"
          >
            搜索
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      keyworder: "",
    };
  },
  methods: {
    getSeach() {
      if (!this.keyworder.trim()) return;
      this.$router.push({
        name: "search",
        params: {
          name: this.keyworder,
        },
      });
    },
  },
  props: ["bannerH", "bannerP", "bannerImg"],
};
</script>

<style scoped lang="less">
@import "../assets/styles/variables.less";

.banner-wrapper {
  position: relative;
  width: 100%;
  height: 320px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.banner-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-container {
  display: flex;
  justify-content: center;
}

.search-box {
  background: #ffffff;
  padding: 6px;
  border-radius: 50px;
  display: flex;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;

  &:focus-within {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  input {
    flex: 1;
    border: none;
    padding: 0 24px;
    font-size: 16px;
    color: @text-main;
    background: transparent;
    &::placeholder { color: @text-muted; }
  }

  .search-btn {
    border-radius: 50px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(52, 148, 236, 0.3);
  }
}
</style>
